export default "__VITE_ASSET__CuSykmhm__"